module.exports = __webpack_public_path__ + "static/media/ic_empty.3f593a1a.svg";